import { COLORS, FONTS } from '../../../../constants';

const styles = theme => {
  // take mobile-first approach to do the styling
  const minSm = theme.breakpoints.up('sm');
  const minMd = theme.breakpoints.up('md');
  const maxXs = theme.breakpoints.down('xs');

  return {
    actionsRow: {
      marginTop: 50,
    },
    formButtons: {
      display: 'flex',

      '& > button': {
        flex: '1',
      },
      '& > button:first-child': {
        marginRight: 5,
      },
      '& > button:last-child': {
        marginLeft: 5,
      },
      [minMd]: {
        display: 'block',
        textAlign: 'right',

        '& > button': {
          width: 150,
          flex: 'none',
        },
      },
    },
    editButton: {
      width: '100%',
      [minMd]: {
        width: 150,
      },
    },
    formRow: {
      width: '100%',
      [minSm]: {
        display: 'flex',
        justifyContent: 'space-between',
      },
    },
    formGroup: {
      width: '100%',
      marginTop: 24,
    },
    halfFormGroup: {
      width: '100%',
      [minSm]: {
        width: '48%',
      },
    },
    textCenter: {
      textAlign: 'center',
    },
    profilePhoto: {
      height: '200px',
      width: '200px',
      objectFit: 'cover',
      borderRadius: '10px',
    },
    photoUpload: {
      height: '200px',
      width: '200px',
      backgroundColor: '#f1f1f1',
      borderRadius: '10px',
      margin: '8px 10px 0 0',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',

      flexDirection: 'column',
    },
    remove: {
      position: 'absolute',
      top: '5%',
      right: '8%',
      border: '1px solid white',
      borderRadius: '50%',
      color: 'white',
      display: 'flex',
      width: ' 20px',
      height: ' 20px',
      alignItems: 'center',
      justifyContent: 'center',
      cursor: 'pointer',
      boxSizing: 'border-box',
      backgroundColor: 'rgb(10 10 10 / 62%)',
      borderStyle: 'solid',
    },
    imageContainer: {
      position: 'relative',
    },
    topImageFormGroup: {
      marginTop: '30px',
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      [maxXs]: {
        display: 'block',
      },
    },
    topImageSingle: {
      display: 'flex',
      alignItems: 'center',
      '& p': {
        marginLeft: 5,
      },
    },
    galleryImages: {
      display: 'flex',
      flexWrap: 'wrap',
      '& img': {
        margin: '8px 10px 0 0',
      },
    },
    textLabel: {
      fontFamily: FONTS.PRIMARY,
      textTransform: 'uppercase',
      color: COLORS.GREY_DARKER,
      fontSize: '0.75rem',
      fontWeight: 600,
    },
    anchor: {
      cursor: 'pointer',
      display: 'flex',
      width: '100%',
      height: '100%',
      justifyContent: 'center',
      alignItems: 'center',
    },
    caption: {
      position: 'absolute',
      width: '200px',
      height: ' auto',
      bottom: '8px',
      left: '0px',
      color: '#ffffff',
      background: 'rgba(0,0,0,0.3)',
      textAlign: 'center',
      borderRadius: '0 0 10px 10px',
    },
  };
};

export default styles;
